import 'antd/dist/antd.compact.css'
import 'antd-button-color/dist/css/style.css';
import './core/styles/soft-theme.css';

import { UserProvider } from "./core/context/UserContext";
import HisRouter from "./HisRouter";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Flex from "./core/components/Flex";
import MoonLoader from "react-spinners/MoonLoader";
import { ModalProvider } from "./core/context/ModalContext";
import Modal from "./core/components/Modal";

export default function HisApp() {

    return (
        <div id={'his-container'} style={{ height: '100%' }}>
            <div
                id={'request-spinner'}
                style={{
                    display: 'none',
                    position: 'fixed',
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#00000020',
                    zIndex: 9999
                }}
            >
                <Flex style={{ height: '100%' }} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} justifyItems={'center'}>
                    <MoonLoader color={'#0000ff'} size={80} />
                </Flex>
            </div>
            <div className="App">
                <UserProvider>
                    <ModalProvider>
                        <HisRouter />
                        <Modal />
                    </ModalProvider>
                </UserProvider>

                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </div>
    )
}
